import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_85: FaireProductEntity = {
  token: "catalog_prod_prod-85",
  type: "product",
  name: "Ornament Set",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=400&fit=crop",
  priceDollars: 44.49,
  msrpDollars: 111.23,
  sku: "AN0085",
  caseSize: 6,
  material: "Metal",
  collectionToken: "col_andean-touch",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 271,
  description: "Beautiful Andean Touch piece perfect for any home.",
  categoryTokens: ["cat_household-all"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
